module.exports = __webpack_public_path__ + "static/media/login-img.fec5ab15.svg";